import { RichText } from '@wordpress/block-editor';
import InfoBoxOne from './InfoBoxOne';

const InfoBoxWrapper = ( { attributes } ) => {
	const { text, padding } = attributes;

	const style = {
		padding: `${ padding.desktop.sideTop }${ padding.desktop.unit } ${ padding.desktop.sideRight }${ padding.desktop.unit } ${ padding.desktop.sideBottom }${ padding.desktop.unit } ${ padding.desktop.sideLeft }${ padding.desktop.unit }`,
	};

	return (
		<div style={ style }>
			<RichText.Content tagName="p" value={ text } />
			<InfoBoxOne title={ 'info Box Title' } children={ 'The Content' } />
		</div>
	);
};

export default InfoBoxWrapper;
